// components/MenuItemsTable/PaymentOptions.js
import React from 'react';

const PaymentOptions = ({
  orderType,
  setOrderType,
  selectedAddressObj,
  onShowAddressPopup,
  showPaymentOptions,
  setShowPaymentOptions,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  selectedwalletTypes,
  setSelectedwalletTypes,
  onPlaceOrder,
  orderPlacing,
  onOpenScheduleModal,
  availableBalance,
  availableSelf,
  availableCompany,
  availableCashback
}) => {
  const paymentMethods = [
    { id: 'Maamaas_Wallet', icon: '👛', label: `Wallet (₹${availableBalance.toFixed(2)})` },
    { id: 'Online_Payment', icon: '💳', label: 'Online Payment' },
  ];

  const walletTypes = [
    { key: 'Self Loaded', label: 'Self Loaded', bal: availableSelf },
    { key: 'Company Loaded', label: 'Company Loaded', bal: availableCompany },
    { key: 'Cashback', label: 'Cashback', bal: availableCashback },
  ];

  return (
    <div>
      {/* Order Type */}
      {/* <select
        value={orderType}
        onChange={(e) => {
          setOrderType(e.target.value);
          if (e.target.value === 'DELIVERY' && !selectedAddressObj) onShowAddressPopup(true);
        }}
        style={{
          width: '100%',
          padding: '12px',
          borderRadius: '10px',
          border: '1px solid #ddd',
          marginBottom: '12px',
          fontSize: '14px'
        }}
      >
        <option value="DELIVERY">🚚 Delivery</option>
        <option value="DINE_IN">🍽️ Dine In</option>
        <option value="TAKEAWAY">📦 Takeaway</option>
      </select> */}

      {/* Address Display for Delivery */}
      {orderType === 'DELIVERY' && (
        <div
          onClick={() => onShowAddressPopup(true)}
          style={{
            padding: '14px',
            backgroundColor: selectedAddressObj ? '#f0fdf4' : '#fff3e0',
            borderRadius: '10px',
            marginBottom: '12px',
            cursor: 'pointer',
            border: `1px solid ${selectedAddressObj ? '#22c55e' : '#ff9800'}`
          }}
        >
          {selectedAddressObj ? (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                <span>✅</span>
                <span style={{ fontWeight: 'bold', color: '#22c55e' }}>Delivery Address Selected</span>
              </div>
              <div style={{ fontSize: '13px' }}>📍 {selectedAddressObj.address || selectedAddressObj.addressLine}</div>
              {selectedAddressObj.name && (
                <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                  {selectedAddressObj.name} | {selectedAddressObj.phoneNumber}
                </div>
              )}
            </>
          ) : (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>⚠️</span>
                <span style={{ fontWeight: 'bold', color: '#ff9800' }}>Add Delivery Address</span>
              </div>
              <div style={{ fontSize: '12px', marginTop: '4px' }}>Click to add delivery address</div>
            </>
          )}
        </div>
      )}

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
        <button
          onClick={onOpenScheduleModal}
          disabled={showPaymentOptions}
          style={{
            flex: 1,
            padding: '12px',
            backgroundColor: '#fff',
            color: '#ee6521',
            border: '2px solid #ee6521',
            borderRadius: '30px',
            fontWeight: 'bold',
            cursor: showPaymentOptions ? 'not-allowed' : 'pointer',
            opacity: showPaymentOptions ? 0.6 : 1
          }}
        >
          📅 Schedule
        </button>
        
        {!showPaymentOptions ? (
          <button
            onClick={() => {
              if (orderType === 'DELIVERY' && !selectedAddressObj) {
                onShowAddressPopup(true);
                return;
              }
              setShowPaymentOptions(true);
            }}
            style={{
              flex: 1,
              padding: '12px',
              backgroundColor: '#ee6521',
              color: '#fff',
              border: 'none',
              borderRadius: '30px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Checkout
          </button>
        ) : (
          <button
            onClick={() => setShowPaymentOptions(false)}
            style={{
              flex: 1,
              padding: '12px',
              backgroundColor: '#6b7280',
              color: '#fff',
              border: 'none',
              borderRadius: '30px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Back
          </button>
        )}
      </div>

      {/* Payment Options */}
      {showPaymentOptions && (
        <div style={{ marginTop: '16px' }}>
          <div style={{ fontWeight: 'bold', marginBottom: '12px', fontSize: '15px' }}>
            Select Payment Method
          </div>
          
          {paymentMethods.map(pm => (
            <div
              key={pm.id}
              onClick={() => {
                setSelectedPaymentMethod(pm.id);
                if (pm.id !== 'Maamaas_Wallet') setSelectedwalletTypes(null);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px',
                borderRadius: '12px',
                marginBottom: '10px',
                cursor: 'pointer',
                border: `2px solid ${selectedPaymentMethod === pm.id ? '#ee6521' : '#e5e7eb'}`,
                backgroundColor: selectedPaymentMethod === pm.id ? '#fff8f5' : '#fff'
              }}
            >
              <span style={{ fontSize: '26px' }}>{pm.icon}</span>
              <span style={{
                flex: 1,
                fontSize: '14px',
                fontWeight: selectedPaymentMethod === pm.id ? '600' : '400'
              }}>
                {pm.label}
              </span>
              <div style={{
                width: '22px',
                height: '22px',
                borderRadius: '50%',
                border: `2px solid ${selectedPaymentMethod === pm.id ? '#ee6521' : '#ccc'}`,
                backgroundColor: selectedPaymentMethod === pm.id ? '#ee6521' : '#fff'
              }}></div>
            </div>
          ))}

          {/* Wallet Type Selection */}
          {selectedPaymentMethod === 'Maamaas_Wallet' && (
            <div style={{ marginTop: '12px', padding: '14px', backgroundColor: '#f9f9f9', borderRadius: '12px' }}>
              <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>
                Select Wallet Type:
              </div>
              {walletTypes.map(wt => (
                <div
                  key={wt.key}
                  onClick={() => setSelectedwalletTypes(wt.key)}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '12px',
                    borderRadius: '10px',
                    marginBottom: '8px',
                    cursor: 'pointer',
                    backgroundColor: selectedwalletTypes === wt.key ? '#fff8f5' : '#fff',
                    border: `1px solid ${selectedwalletTypes === wt.key ? '#ee6521' : '#ddd'}`
                  }}
                >
                  <span>{wt.label}</span>
                  <span style={{ color: '#22c55e', fontWeight: 'bold' }}>₹{wt.bal.toFixed(2)}</span>
                </div>
              ))}
            </div>
          )}

          {/* Place Order Button */}
          <button
            onClick={onPlaceOrder}
            disabled={orderPlacing || !selectedPaymentMethod || (selectedPaymentMethod === 'Maamaas_Wallet' && !selectedwalletTypes)}
            style={{
              width: '100%',
              padding: '14px',
              marginTop: '16px',
              backgroundColor: (selectedPaymentMethod && !(selectedPaymentMethod === 'Maamaas_Wallet' && !selectedwalletTypes)) ? '#ee6521' : '#ccc',
              color: '#fff',
              border: 'none',
              borderRadius: '30px',
              fontWeight: 'bold',
              fontSize: '15px',
              cursor: (selectedPaymentMethod && !(selectedPaymentMethod === 'Maamaas_Wallet' && !selectedwalletTypes)) ? 'pointer' : 'not-allowed'
            }}
          >
            {orderPlacing ? '⏳ Placing Order...' : '🛒 Place Order'}
          </button>
        </div>
      )}
    </div>
  );
};

export default PaymentOptions;